import { action, configure, observable, makeObservable } from "mobx";
import { ApiBasePath } from "../../utils/ApiBasePath";

configure({ enforceActions: "always" });
export default class ServiceBookingStore {
  @observable preferredDealerSelected?: boolean = false;
  @observable xTimeIFrameSource?: string = "";
  @observable xTimeBaseUrl?: string = ApiBasePath.xtime;
  @observable xTimeKey?: string = "";
  @observable xTimeIFrameLoading?: boolean = false;
  @observable gotoNextStep?: boolean = false;
  @observable serviceBookingTerms = window["serviceBookingTerms"];
  @observable serviceBookingIntroText = window["serviceBookingIntroText"];

  constructor() {
    makeObservable(this);
    window.addEventListener("dealerSelected", (e: any) => this.dealerSelected(e));
  }

  log(message: string): void {
    document.location.href.indexOf("?log") > -1 && console.log(`ServiceBookingStore => ${message}`);
  }

  @action dealerSelected(e: any): void {
    console.log(e);
    var selectedDealer = e.detail.dealer;
    if (selectedDealer && selectedDealer.xTimeKey) {

      switch (selectedDealer.crmDealerId) {
        case '144130':
          this.xTimeKey = `${selectedDealer.xTimeKey}&VARIANT=SUBARU_AUSTRALIA&WMODE=true&Dest=SERVICE&skipRedirect=true`;
          break;
        case '133075':
          this.xTimeKey = `${selectedDealer.xTimeKey}&skipRedirect=true&VARIANT=SUBARUAUSTRALIA&WMODE=true`;
          break;
        default:
          this.xTimeKey = selectedDealer.xTimeKey;
          break;
      }
      
      this.preferredDealerSelected = true;
    } else {
      this.preferredDealerSelected = false;
    }

    this.log(selectedDealer ?
      `Dealer Selected: ${selectedDealer.name} => XTimeKey: ${selectedDealer.xTimeKey}` :
      `Dealer Selected => empty dealer`);
  }

  @action setGotoNextStep = (next: boolean) => {
    if (!this.xTimeIFrameLoading) {
      this.xTimeIFrameLoading = true;
    }
    this.xTimeIFrameSource = `${this.xTimeBaseUrl}/?&webKey=${this.xTimeKey}&variant=subaru_australia`;
    this.gotoNextStep = next;
  };

  @action setxTimeIFrameLoading = (setting: boolean) => {
    this.xTimeIFrameLoading = setting;
  };
}
